var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMainRight = function SvgMainRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "<Layer>",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.01 44h12l11.55-20L25.01 4h-12l11.55 20-11.55 20z"
  })));
};
export { SvgMainRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iYjk5ZGNmNGYtZTU5OC00OTBhLThkZDAtYTJhNTc5MTk5MTQwIiBkYXRhLW5hbWU9IiZsdDtMYXllciZndDsiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+bWFpbl9yaWdodDwvdGl0bGU+PHBvbHlnb24gcG9pbnRzPSIxMy4wMSA0NCAxNy4wMSA0NCAxNy4wMSA0NCAyMS4wMSA0NCAyMS4wMSA0NCAyNS4wMSA0NCAzNi41NiAyNCAyNS4wMSA0IDIxLjAxIDQgMjEuMDEgNCAxNy4wMSA0IDE3LjAxIDQgMTMuMDEgNCAyNC41NiAyNCAxMy4wMSA0NCIvPjwvc3ZnPgo=";